module.exports = __webpack_public_path__ + "img/avatar4.c2a0a908.png";